import { createI18n } from 'vue-i18n';

type LocaleMessageValue = string | { [key: string]: LocaleMessageValue };
type LocaleMessages = Record<string, { [key: string]: LocaleMessageValue }>;

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i) as __WebpackModuleApi.RequireContext;
  const messages: LocaleMessages = {};
  locales.keys().forEach((key: string) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      const localeModule = locales(key) as { default?: LocaleMessages[string] } | LocaleMessages[string];
      messages[locale] = ("default" in localeModule ? localeModule.default : localeModule) as LocaleMessages[string];
    }
  });
  return messages;
}

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
});
